// **** import modules ****
import $ from "jquery";
import { csl } from "@pressmedia/webappbase";


// **** process ****
export default {
	init() {
		const components = window.app.components;
		
		this.$element = $("#site_footer");
		
		components.$siteFooter = this.$element;
		
		return this;
	},
	
	fixBottom() {
		const components = window.app.components;
		
		(this.$element === undefined) && this.init();
		
		if(!this.$element.length) {
			csl.log.grey("no siteFooter.");
			return this;
		}
		
		// 親要素を格納
		this.$container = this.$element.parent();
		(this.$container.length > 1) && ( this.$container = this.$container.eq(0) );
		(this.$container.css("position") === "static") && this.$container.css("position", "relative");
		this.$container.isBorderBox = (this.$container.css("box-sizing") === "border-box") ? true : false;
		
		// documentElement
		this.$document = $(document.documentElement);
		
		// for window resize event
		components.$window.on("resize", e => {
			clearTimeout(this._fixTimer);
			this._fixTimer = setTimeout(() => this._updStyle(), 100);
		});
		
		this._updStyle().$element.css({
			position: "absolute",
			bottom: 0,
			left: 0
		}).addClass("fixed-bottom");
		
		return this;
	},
	
	_updStyle() {
		const components = window.app.components;
		const css = {
			"min-height": components.$window.outerHeight() - 1,
			"padding-bottom": this.$element.outerHeight(true)
		};
		this.$container.isBorderBox || (css["min-height"] -= css["padding-bottom"]);
		
		css["min-height"] -= parseFloat( this.$document.css("margin-top") );
		css["min-height"] -= parseFloat( this.$document.css("margin-bottom") );
		
		this.$container.css(css);
		
		return this;
	}
};
